/**
 * @flow
 */

import { parseEncodedTextFromString } from "../utils/htmlParsingUtils";

export type RegionFacility = {|
  id: number,
  name: string,
  shortName: ?string,
  displayString: ?string,
|};

export type RawRegionFacility = {
  id: number,
  name: string,
  short_name: ?string,
  display_str: ?string,
};

export const parseRawRegionFacility = (rawRegionFacility: RawRegionFacility): RegionFacility => {
  const { id, name, ...rest } = rawRegionFacility;
  return {
    id,
    name: parseEncodedTextFromString(name),
    shortName: rest.short_name,
    displayString: parseEncodedTextFromString(rest.display_str),
  };
};
